import { render, staticRenderFns } from "./view-messages.vue?vue&type=template&id=2544486c&scoped=true"
import script from "./view-messages.vue?vue&type=script&lang=js"
export * from "./view-messages.vue?vue&type=script&lang=js"
import style0 from "./view-messages.vue?vue&type=style&index=0&id=2544486c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544486c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2544486c')) {
      api.createRecord('2544486c', component.options)
    } else {
      api.reload('2544486c', component.options)
    }
    module.hot.accept("./view-messages.vue?vue&type=template&id=2544486c&scoped=true", function () {
      api.rerender('2544486c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue-view/view-messages.vue"
export default component.exports